// 文章相关请求模块

import request from '../untils/request'

// 获取首页id列表
export const homeID  = () => {
// const token = JSON.parse(window.sessionStorage.getItem('token'))
    return request({
        method: 'GET',
        url: '/lsg-manage/user/system/querySelf',
        // headers: {
        //         //属性名和值都得看后端的要求
        //         //属性名：Authorization ，接口要求的
        //         //属性值：Bearer空格token数据
        //         Authorization: `Bearer ${token}`
        //     }
    })
}
// 获取管理员id
export const idPass = () => {
    return request({
        method: 'GET',
        url: '/lsg-manage/user/user/querySelf',
    })
}
// 获取首页列表
export const homeList = params => {
    return request({
        method: 'GET',
        url: '/lsg-manage/user/permission/queryTenantAllPermissionList',
        params
    })
}
// 获取首页列表(用户)
export const querySelfAllPermissionList = params => {
    return request({
        method: 'GET',
        url: '/lsg-manage/user/permission/querySelfAllPermissionList',
        params
    })
}
// 获取排行榜分组列表
export const getGroupList = params => {
    return request({
        method: 'GET',
        url: '/api',
        params
    })
}
// 获取订阅分组数据
export const timeList = () => {
    return request({
        method: 'GET',
        url: '/lsg-bigscreen/ranking/userSubscription',
    })
}
// 获取微信列表
export const wxList = params => {
    return request({
        method: 'GET',
        url: '/lsg-bigscreen/ranking/getWeixinRanking',
        params
    })
}
// 获取抖音排行榜列表
export const getDyRanking = params => {
    return request({
        method: 'GET',
        url: '/lsg-bigscreen/ranking/getDyRanking',
        params
    })
}
// 获取视频号排行榜列表
export const getSphRanking = params => {
    return request({
        method: 'GET',
        url: '/lsg-bigscreen/ranking/getSphRanking',
        params
    })
}
// 获取快手排行榜列表
export const getKsRanking = params => {
    return request({
        method: 'GET',
        url: '/lsg-bigscreen/ranking/getKsRanking',
        params
    })
}
// 获取微博列表
export const wbList = params => {
    return request({
        method: 'GET',
        url: '/lsg-bigscreen/ranking/getWeiboRanking',
        params
    })
}

// 新闻地图接口
export const getNewsList = params => {
    return request({
        method: 'GET',
        url: '/lsg-bigscreen/newsMap/getNewsByCity',
        params
    })
}

